var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKalmarLogoNewRoundRed = function SvgKalmarLogoNewRoundRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    transform: "rotate(-180 20 20)",
    fill: "#F30000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.533 10.4h-9.877s-.702 2.564-2.268 4.663c-1.658 2.221-4.189 3.988-4.296 4.095 4.658 0 10.685.79 16.44-8.758h.001ZM16.092 10.408v8.758c-1.957 0-7.708-1.207-7.268-8.758M32.533 28.793h-9.877s-.702-2.564-2.268-4.663c-1.658-2.221-4.189-3.988-4.296-4.095 4.658 0 10.686-.79 16.441 8.758ZM16.092 28.785v-8.758c-1.957 0-7.708 1.207-7.268 8.758",
    fill: "#fff"
  })));
};
export default SvgKalmarLogoNewRoundRed;